import { useState } from "react";

function UnlockScreen(props) {
    const [value, setValue] = useState("");

    const localStorageName = "log_in_status";
    const timeNow = Date.now();
    const timeFromLS = localStorage.getItem("log_in_status");

    if (timeFromLS) {
        if (((timeNow - timeFromLS)/1000/60) < 60) {
            props.setAccess(true);
            console.log("Still true: (" + ((timeNow - timeFromLS)/1000/60) + ")");
            
        };
    };

    const onLogIn = () => {
        const obviousPassword = "2357"
        if (value === obviousPassword) {
            props.setAccess(true);
            localStorage.setItem(localStorageName, Date.now())
        };
    };

    return (
        <div id="unlock-screen">
            <input onKeyDown={(e) => {if(e.key.toLowerCase() === "enter"){onLogIn()}}} type="password" placeholder="Passord" value={value} onChange={(e) => {setValue(e.target.value)}} />
            <button onClick={onLogIn}>Log inn</button>
        </div>
    );
};

export default UnlockScreen;